import {
    resolveShowProductSection,
    type CountryConfig,
} from '@archipro-website/localisation';
import type { FeatureFlags } from '../hook/use-feature';

/**
 * Whether product-related surfaces should be shown for the current market.
 */
export const isUsProductLaunchEnabled = (
    countryConfig: CountryConfig,
    featureFlags: FeatureFlags,
): boolean => resolveShowProductSection(countryConfig, featureFlags);
